import GenericScreen from "../GenericScreen";
import { Box } from "@mui/material";

import imgScreen from "../../../../../../Assets/StoryRunner/BRD.png";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  t: (key: string) => ReactNode;
}

const Screen = (props: ScreenProps) => {
  const { transition, setStory, screen } = props;

  const handleNextScreen = () => {
    setTimeout(() => setStory({ screen: screen + 1 }), 1000);
  };

  return (
    <>
      <GenericScreen
        showComponent={transition >= 4}
        showContent={true}
        title={"Hi John"}
        text={"Let’s get started! Looks like there is some activity on your Cobalt Airlines App."}
        panelRight={<PhoneScreenOne handleNextScreen={screen === 2 ? handleNextScreen : () => {}} />}
      />
    </>
  );
};

const styles = {
  imgScreen: {
    objectFit: "contain" as "contain",
    width: "100%",
    borderRadius: "26px",
  },
};

interface PhoneScreenOneProps {
  handleNextScreen: () => void;
}

const PhoneScreenOne = (props: PhoneScreenOneProps) => {
  setTimeout(() => {
    props.handleNextScreen();
  }, 2000);
  return (
    <Box sx={{ position: "relative" }}>
      <img style={styles.imgScreen} src={imgScreen} alt="" />
    </Box>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen, mapStateToProps, mapDispatchToProps);
